exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-migraine-relief-js": () => import("./../../../src/pages/migraine-relief.js" /* webpackChunkName: "component---src-pages-migraine-relief-js" */),
  "component---src-pages-my-stack-js": () => import("./../../../src/pages/my-stack.js" /* webpackChunkName: "component---src-pages-my-stack-js" */),
  "component---src-templates-using-dsg-js": () => import("./../../../src/templates/using-dsg.js" /* webpackChunkName: "component---src-templates-using-dsg-js" */)
}

